$( ( $ ) => {
  $.fn.observeElements = function () {
    const bottomRootMargin =
			$( window ).height() > $( window ).width() ? '-8%' : '-16%';
    $( this ).each( ( i, element ) => {
      const observer = new IntersectionObserver(
        ( entries ) => {
          const entry = entries[0];
          if ( entry.isIntersecting ) {
            element.classList.add( 'bs-appeared' );
            observer.disconnect();
          }
        },
        {
          root: null,
          rootMargin: '0px 0px ' + bottomRootMargin + ' 0px',
        }
      );
      observer.observe( element );
    } );
  };
  $(
    '.bs-section--observe,.bs-div--observe,.bs-blurb--observe,.bs-slider--observe'
  ).observeElements();
} );
